import React from "react";

import {
	scrollStart,
	scrollEnd,
	getTranslatedGameName,
} from "@/modules/commonMobile";

import {
	assetImg
} from "@/modules/moduleImporter";

import {
	IGameObjectType,
	IGameType,
	IKeyStringArrayDict,
	ILanguageType
} from "@/types/GlobalTypes";

import {
	getBasePcode,
	getAssetPcode,
	getFirstTotoPcode,
	isTotoGroup,
	getAvailableTotoPcodes,
	getGroupSize,
} from "@/modules/gamePcode";

interface IProps {
	games: IGameObjectType;
	langdata: ILanguageType;

	/**
	 * Either "toto" or base pcode
	 */
	headerGroupCode: string;

	showHeaderGroup: boolean;

	gameGroups: IKeyStringArrayDict;

	activeGamePcodes: string[];

	closeHeaderGroup: (e: React.MouseEvent) => void;
	renderGame: (e: React.MouseEvent) => void;
	toggleHeaderGroup: (e: React.MouseEvent) => void;
}


export default class HeaderGameList extends React.PureComponent<IProps> {
	// setter: initDragScroll
	private targetContainer: Node;

	/**
	 * For click + hold scrolling function
	 */
	private initDragScroll() {
		window.setTimeout((self: HeaderGameList) => {
			self.targetContainer = document.getElementById("sl-game-container");
			if (self.targetContainer)
				self.targetContainer = self.targetContainer.childNodes[0];
		}, 500, this);
	}

	private headerIcon(assetPcode: string) {
		return assetImg("game_icon", assetPcode + ".svg");
	}

	private newGameBadge(game: IGameType) {
		if (game.newgame !== "1")
			return null;

		return (
			<div className="badge-new">
				{this.props.langdata["txt_new_game_badge"]}
			</div>
		);
	}

	/**
	 * Smaller game box under gameBox
	 * Used in subGameFragment()
	 */
	private subGameBox(pcode: string) {
		//Same as above
		const
			{ games, activeGamePcodes, langdata, renderGame } = this.props,
			assetPcode = getAssetPcode(pcode),
			icon = this.headerIcon(assetPcode),
			game = games[pcode];

		const
			key = "sgc_gBp_" + pcode,
			classNames = [
				"game",
				(game.active ? "active" : ""),

				// in case the game is minimised (from multi table)
				(!game.active && activeGamePcodes.includes(pcode) ? " background" : "")
			].join(" ");

		return (
			<div key={key} className={classNames}
				{...{ game: pcode }}
				onClick={renderGame}>

				{icon}

				<div>
					<div>
						{getTranslatedGameName(langdata, pcode, true)}
					</div>
				</div>

				{this.newGameBadge(game)}
			</div>
		);
	}

	/**
	 * Used in gameBox()
	 */
	private subGameFragment(parentCode: string) {
		const
			{ games, headerGroupCode, showHeaderGroup } = this.props,

			gamePcodes = Object.keys(games),
			subGames = isTotoGroup(parentCode)
				? getAvailableTotoPcodes(gamePcodes)
				: gamePcodes.filter(pcode =>
					getBasePcode(pcode) === headerGroupCode
				);

		// console.log("parentCode & subGames: ", parentCode, subGames);

		return (
			subGames &&
			parentCode === headerGroupCode &&
			showHeaderGroup && (
				<div className="header-game-group-container">
					{subGames.map(pcode => this.subGameBox(pcode))}
				</div>
			)
		);
	}

	/**
	 * Each Game on the header
	 * Used in gameContainerFragment()
	 * @param code "toto" or base pcode
	 */
	private gameBox(code: string) {
		const
			{
				activeGamePcodes,
				games,
				gameGroups,
				langdata,
				renderGame,
				toggleHeaderGroup
			} = this.props,

			gameHasGroup = getGroupSize(gameGroups[code]),
			pcode = isTotoGroup(code)
				? getFirstTotoPcode(gameGroups[code])
				: gameGroups[code][0],

			assetPcode = getAssetPcode(pcode),

			game = games[pcode],
			icon = this.headerIcon(assetPcode);

		return (
			<div key={"sgc_gBp_" + pcode}
				className={"game" +
					(gameHasGroup ? " has-group" : "") +
					(!gameHasGroup && game.active ? " active" : "") +
					(!game.active && activeGamePcodes.includes(pcode) ? " background" : "")
				}

				{...{
					game: pcode,
					groupgame: code
				}}

				onClick={gameHasGroup ? toggleHeaderGroup : renderGame}>

				{icon}

				<div>
					<div>
						{getTranslatedGameName(langdata, pcode)}
					</div>
				</div>

				{this.subGameFragment(code)}
				{this.newGameBadge(game)}
			</div>
		);
	}

	/**
	 * Used in render()
	 */
	private gameContainerFragment() {
		const
			{ showHeaderGroup, closeHeaderGroup, gameGroups } = this.props;

		return (
			<div id="sl-game-container" className="sl-game-container">
				<div className="gameBox dragscroll">
					{
						showHeaderGroup
							? (
								<div
									className="close-header-overlay"
									onClick={closeHeaderGroup} />
							) : null
					}

					{
						Object.keys(gameGroups)
						.map(code => this.gameBox(code))
					}
				</div>
			</div>
		);
	}

	/**
	 * Used in render()
	 */
	private scrollSpan(increment: number, caret: "left" | "right") {
		return (
			<span className="cursor"

				{...{
					increment,
					direction: "horizontal"
				}}

				onMouseDown={scrollStart.bind(this)}
				onMouseUp={scrollEnd.bind(this)}
			>
				<i className={"fas fa-caret-" + caret} />
			</span>
		);
	}

	render() {
		this.initDragScroll();

		return (
			<div className="sl-box-game">
				{this.scrollSpan(-1, "left")}
				{this.gameContainerFragment()}
				{this.scrollSpan(1, "right")}
			</div>
		);
	}
}
